import { render, staticRenderFns } from "./EditPersonDialog.vue?vue&type=template&id=3b5828d2&scoped=true&lang=pug"
import script from "./EditPersonDialog.vue?vue&type=script&lang=js"
export * from "./EditPersonDialog.vue?vue&type=script&lang=js"
import style0 from "./EditPersonDialog.vue?vue&type=style&index=0&id=3b5828d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5828d2",
  null
  
)

export default component.exports